import { render } from "./LottieAnimation.vue?vue&type=template&id=c2e112d4"
import script from "./LottieAnimation.vue?vue&type=script&lang=js"
export * from "./LottieAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__